export default class PageFilter {
    constructor() {
        this.page = 1;
        this.size = 20;
    }
    asQuery() {
        let filter = {};
        filter.page = this.page;
        filter.size = this.size;
        return filter;
    }
    asQueryForMap(size) {
        let filter = {};
        filter.page = 1;
        filter.size = size;
        return filter;
    }
}